import { APIClient } from '@frontend/api-utils';

export class FunctionalityJsonClient extends APIClient {
    public static readonly endpoint = '/functionality-api/json/v1';

    public static async fetchSingleFunctionalityJson(accountId: string, functionalityId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/functionalities/${functionalityId}`);
        return await this.handleBlobResponse(response);
    }
}
